import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { SharedModule } from '../shared/shared.module';
import { LogInSignUpComponent } from './log-in-sign-up/log-in-sign-up.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { InvitationsComponent } from './invitations/invitations.component';
import { AgGridModule } from 'ag-grid-angular';
import { OauthComponent } from './oauth/oauth.component';
import { FullMaterialModule } from 'src/app/material/material-module';
import { ExtensionComponent } from './extension/extension.component';
import {
  SocialLoginModule,
  SocialAuthServiceConfig,
  GoogleSigninButtonDirective,
} from '@abacritt/angularx-social-login';
import { GoogleLoginProvider, MicrosoftLoginProvider } from '@abacritt/angularx-social-login';
import { environment } from 'src/environments/environment';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [
    LogInSignUpComponent,
    ResetPasswordComponent,
    InvitationsComponent,
    OauthComponent,
    ExtensionComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    MatIconModule,
    AgGridModule,
    FullMaterialModule,
    SocialLoginModule,
    RouterModule,
    GoogleSigninButtonDirective,
  ],
  exports: [LogInSignUpComponent],
  providers: [
    {
      provide: 'SocialAuthServiceConfig',
      useValue: {
        autoLogin: false,
        providers: [
          {
            id: GoogleLoginProvider.PROVIDER_ID,
            provider: new GoogleLoginProvider(environment.googleAuthClientId, {
              oneTapEnabled: false,
            }),
          },
          {
            id: MicrosoftLoginProvider.PROVIDER_ID,
            provider: new MicrosoftLoginProvider(environment.microsoftAuthClientId, {
              redirect_uri: window.location.origin + '/assets/auth-redirect.html',
              logout_redirect_uri: window.location.origin,
              scopes: ['openid', 'email', 'profile', 'User.Read'],
              prompt: 'select_account',
              cacheLocation: 'localStorage',
            }),
          },
        ],
        onError: (err) => {
          console.error(err);
        },
      } as SocialAuthServiceConfig,
    },
  ],
})
export class AuthModule {}
